import { useQuery } from '@tanstack/react-query';
import statusApiFunctions from '../api/status';
import { Queries } from '../types/queries';
import { ComponentStatusCheck } from '../types/componentStatus';
import { useEffect } from 'react';

const useComponentStatusData = (callback: Function) => {
  const { data, dataUpdatedAt, isFetching, isLoading, isError, refetch } = useQuery<Array<ComponentStatusCheck>>({
    queryKey: Object.values(Queries.ComponentStatusList),
    queryFn: async () => await statusApiFunctions.getComponentStatusCheckList(),
    refetchInterval: 300000, //5 min refresh
    refetchOnWindowFocus: false,
  });

  useEffect(() => callback(data), [data, dataUpdatedAt]);

  return { data, isFetching, isLoading, isError, refetch };
};

export default useComponentStatusData;
